/* global GOOGLE_ANALYTICS_UA:true */
'use strict'

import common from '../../lib/common'
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import store from '../../store'
import { strings } from '../../lib/strings'
import Page from '../../components/Page'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import normalize from '../../css/normalize.css' // eslint-disable-line no-unused-vars
import h5bp from '../../css/h5bp.css' // eslint-disable-line no-unused-vars
import style from '../../css/style.css' // eslint-disable-line no-unused-vars
import { init as initApm } from '@elastic/apm-rum'

require('es6-promise').polyfill() //required for IE 11

const sharedState = { lang: '' }
sharedState.defaultStrings = strings
sharedState.strings = strings.en
sharedState.common = common
sharedState.logClientErrorToAPM = () => {}

function ariaReadText(text) {
  sharedState.textToRead = ''
  Vue.nextTick(function() {
    sharedState.textToRead = text
  })
}

Vue.prototype.$ariaReadText = ariaReadText

const pathParts = window.location.pathname.split('/')
if (pathParts && pathParts[2] && pathParts[2].toLowerCase() === 'fr') {
  sharedState.lang = 'fr'
} else {
  sharedState.lang = 'en'
}

common
  .loadConfig('/config.json')
  .then(config => {
    Vue.set(sharedState, 'config', config)
    if (config.apmServerUrl) {
      sharedState.logClientErrorToAPM = common.setUpAPM(
        initApm({
          serviceName: 'IPRelayBrowser',
          serverUrl: config.apmServerUrl,
          serviceVersion: config.build,
          active: config.environment !== 'development',
        })
      )
    }
    if (config.css) {
      Object.keys(config.css).forEach(key => {
        sharedState.common.customSheet().insertRule(key + ' ' + config.css[key], 0)
      })
    }
    if (config.favicon) {
      document.querySelector('link[rel*="icon"]').href = config.favicon
    }
    if (config.strings) {
      Object.assign(sharedState.defaultStrings.en, config.strings.en)
      Object.assign(sharedState.defaultStrings.fr, config.strings.fr)
      sharedState.common.setLanguage(sharedState, sharedState.lang)
    }
  })
  .catch(() => {})

const id = GOOGLE_ANALYTICS_UA
Vue.use(VueAnalytics, { id })

store.commit({
  type: 'setSharedState',
  sharedState,
})

new Vue({
  store,
  el: '#pageApp',
  render: h => h(Page),
})
